export default __webpack_public_path__ + "src/public/PerceptionHealth-powered-footer@2x.png";